module.exports = __webpack_public_path__ + "img/img-8.8b00ace9.jpg";